import { Link } from "react-router-dom";
import GeoMark from "./GeoMark";

const Logo = ({ dark = false }) => (
  <Link
    to="/"
    data-testid="logo-link"
    className="group flex items-center gap-3"
    aria-label="Arch Expo AG — home"
  >
    <GeoMark size={30} dark={dark} />
    <span className={`leading-none ${dark ? "text-paper" : "text-coal"}`}>
      <span className="block text-[15px] font-bold tracking-[0.18em]">ARCH EXPO</span>
      <span className={`block text-[8px] font-semibold tracking-[0.28em] mt-1 ${dark ? "text-paper/50" : "text-graphite"}`}>ARCHITECTURE · DESIGN · EXPO</span>
    </span>
  </Link>
);

export default Logo;
